import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
// import './Chat.css'; // Import your custom CSS file here

const Chat = ({ messages, loading }) => {
  // const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const user = localStorage.getItem("userData");
  const userId = JSON.parse(user)?.data._id;
  function formatTimestamp(timestamp) {
    const date = new Date(timestamp * 1000); // Convert to milliseconds
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // The hour '0' should be '12'
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    return `${day}/${month} ${hours}:${minutes} ${ampm}`;
  }
  const messageContainerRef = useRef(null);
  const scrollToBottom = () => {
    messageContainerRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  if (loading) {
    return <div>Loading......</div>;
  }  
  return (
    <div className="chat-scrollbar mx-auto mt-7 flex h-[60vh] w-full flex-col overflow-y-auto  overflow-x-hidden">
      {/* <h1 className='text-[20px] font-medium text-blue-500 absolute top-0'>Chat</h1> */}
      
      <div className="w-full flex-grow p-4">

      <div >
        {messages.map((msg, index) => {
          const isCurrentUser = msg.sender.toString() === userId.toString();
          console.log(msg,'iamcurentUserFinally')
          const msgTime = formatTimestamp(msg?.created_at);
          return (
            <div
              key={index}
              className={`flex break-words ${
                isCurrentUser ? "justify-end" : "justify-start"
              } mb-2`}
            >
            <div className={`${isCurrentUser ? 'items-end' : 'items-start'} flex flex-col`}>
              <div
                className={`overflow-hidden text-ellipsis rounded-lg p-2 text-white ${
                  isCurrentUser ? "bg-blue-500" : "bg-gray-500"
                }`}
              >
                {msg?.text}
              </div>
              <div className="text-[10px] text-gray-400">{msgTime}</div>
              </div>
            </div>
          );
        })}
        <div ref={messageContainerRef} />
        </div>
      </div>

      {/* <div className="p-2 mb-2 border-t border-gray-300 bg-gray-100 ">
        <div className="flex">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="flex-1 p-2 border border-gray-300 rounded-l-lg"
            placeholder="Type a message"
          />
          <button
            onClick={handleSend}
            className="p-2 bg-blue-500 text-white rounded-r-lg hover:bg-blue-600"
          >
            Send
          </button>
        </div>
      </div> */}
    </div>
  );
};

export default Chat;
